export default Object.freeze({
  DocumentacionDeNomina: 1,
  Analizado: 2,
  CambioDeEstatus: 3,
  Disponible: 4,
  AjusteManual: 5,
  PagoAdicional: 6,
  FacturacionEnLineaSAEE: 7,
  FacturacionEnLineaRP: 8,
  RelacionDePagoPadre: 9,
  RelacionDePagoHijo: 10,
  Comentario: 11,
  JournalDePago: 12,
  GeneracionArchivosDePago: 13,
  Hallazgo: 14,
  ReinicioDocumentacionNomina: 15,
});
